import React from "react";
import Header from "./layouts/Header";
import Recipe from "./Recipe";
import { useSelector } from "react-redux";
import Login from "./Login";
import TopRecipes from "./layouts/TopRecipes";
import { Helmet } from "react-helmet";
import RecipeCard from "./layouts/RecipeCard";
import Grid from "@material-ui/core/Grid";

const HomeScreen = () => {
  const receipe = useSelector((state) => state.receipe);
  const { loading, error, login, topReceipes, filter, underRatedReceipes } =
    receipe;

  const getData = () => (filter?.length !== 0 ? true : false);
  return !loading && !error ? (
    <>
      <Helmet>
        <title>Recipe Share | Home</title>
        <meta name="description" content="Share your receipes here" />
      </Helmet>
      <Header />
      <Recipe />
      {!getData() && <TopRecipes receipes={topReceipes} />}
      {!getData() && underRatedReceipes?.length && (
        <h2 style={{ padding: "0 20px" }}>Under rated Recipes</h2>
      )}
      <Grid container spacing={3}>
        {!getData() &&
          underRatedReceipes?.map((doc) => (
            <RecipeCard
              key={doc.id}
              login={login}
              id={doc.id}
              receipes={doc.data}
            />
          ))}
      </Grid>
    </>
  ) : (
    <Login />
  );
};

export default HomeScreen;
